import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import {BoxedContainer, TitleUppercase, Section} from '../../elements'

const Demos = ({title, bg, color, children}) => (
  <Section padding="both" backgroundColor={bg}>
    <BoxedContainer wide>
      <TitleUppercase
        center
        xlarge
        color={color}
        className="margin--medium--bottom"
        id="demos"
      >
        {title}
      </TitleUppercase>
      <Cards>{children}</Cards>
    </BoxedContainer>
  </Section>
)

export default Demos

Demos.propTypes = {
  title: PropTypes.string,
  bg: PropTypes.string,
  children: PropTypes.node,
}

const Cards = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: -12.5px;

  @media (min-width: ${p => p.theme.breakpoints.xl}) {
    margin: -25px;
  }
`
